import { InfoCircleFilled } from '@ant-design/icons';
import moment from 'moment';
import React from 'react';

import {
  formatarCnpjCpfIMask,
  formatarMoedaIMask,
} from '../../../../helpers/formatador';
import { Tooltip } from '../../CadastroManual/ValoresLote/styles';
import { DeleteOutlined, ExcluirButton, TextStatus } from './styles';

export const getColumns = (
  handleShowModalDelete,
  handleSaveRow,
  showModalTarifas
) => {
  const columns = [
    {
      title: 'Status',
      align: 'center',
      fixed: 'left',
      width: 75,
      render: record => {
        const erro = Object.values(record.errors).length;
        return (
          <>
            <TextStatus color={erro ? '#FF5663' : '#74AA49'}>
              {erro ? 'erro' : 'ok'}
            </TextStatus>
          </>
        );
      },
    },
    {
      title: 'Ações',
      align: 'center',
      fixed: 'left',
      width: 75,
      render: record => (
        <>
          <ExcluirButton onClick={() => handleShowModalDelete(record)}>
            <DeleteOutlined />
          </ExcluirButton>
        </>
      ),
    },
    {
      title: 'Pagador (CNPJ)',
      dataIndex: 'cnpjClientePagador',
      key: 'cnpjClientePagador',
      align: 'center',
      width: 175,
      editable: true,
      required: true,
      inputType: 'select',
      render: text => formatarCnpjCpfIMask(text),
    },
    {
      title: 'Produto',
      dataIndex: 'produto',
      key: 'produto',
      align: 'center',
      width: 175,
      editable: true,
      required: true,
      inputType: 'select',
    },
    {
      title: 'Espécie',
      dataIndex: 'especie',
      key: 'especie',
      align: 'center',
      editable: true,
      required: true,
      inputType: 'select',
    },
    {
      title: 'Cliente Origem',
      dataIndex: 'clienteOrigem',
      key: 'clienteOrigem',
      align: 'center',
      editable: true,
      required: false,
      inputType: 'select',
      tipoCliente: 'Origem',
    },
    {
      title: 'Cidade - UF Origem',
      dataIndex: 'cidadeOrigem',
      key: 'cidadeOrigem',
      align: 'center',
      editable: true,
      required: true,
      inputType: 'select',
      tipoCliente: 'Origem',
    },
    {
      title: 'Cliente Destino',
      dataIndex: 'clienteDestino',
      key: 'clienteDestino',
      align: 'center',
      editable: true,
      required: false,
      inputType: 'select',
      tipoCliente: 'Destino',
    },
    {
      title: 'Cidade - UF Destino',
      dataIndex: 'cidadeDestino',
      key: 'cidadeDestino',
      align: 'center',
      editable: true,
      required: true,
      inputType: 'select',
      tipoCliente: 'Destino',
    },
    {
      title: 'Cliente Coleta',
      dataIndex: 'clienteColeta',
      key: 'clienteColeta',
      align: 'center',
      editable: true,
      required: true,
      inputType: 'select',
      tipoCliente: 'Coleta',
    },
    {
      title: 'Cidade - UF Coleta',
      dataIndex: 'cidadeColeta',
      key: 'cidadeColeta',
      align: 'center',
      editable: true,
      required: true,
      inputType: 'select',
      tipoCliente: 'Coleta',
    },
    {
      title: 'Cliente Entrega',
      dataIndex: 'clienteEntrega',
      key: 'clienteEntrega',
      align: 'center',
      editable: true,
      required: false,
      inputType: 'select',
      tipoCliente: 'Entrega',
    },
    {
      title: 'Cidade - UF Entrega',
      dataIndex: 'cidadeEntrega',
      key: 'cidadeEntrega',
      align: 'center',
      editable: true,
      required: false,
      inputType: 'select',
      tipoCliente: 'Entrega',
    },
    {
      title: 'Volume',
      dataIndex: 'volume',
      key: 'volume',
      align: 'center',
      width: 100,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => text && `${text} T`,
    },
    {
      title: 'Cadência Diária',
      dataIndex: 'cadencia',
      key: 'cadencia',
      align: 'center',
      width: 100,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => text && `${text} T`,
    },
    {
      title: () => (
        <>
          Frete Motorista (PJ)
          <Tooltip placement="right">
            <InfoCircleFilled
              style={{
                color: '#0D3567',
                fontSize: '15px',
              }}
              onClick={showModalTarifas}
            />
          </Tooltip>
        </>
      ),
      dataIndex: 'freteMotoristaPj',
      key: 'freteMotoristaPj',
      align: 'center',
      width: 160,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => {
        if (typeof text === 'number') {
          return formatarMoedaIMask(text);
        }
        return text;
      },
    },
    {
      title: 'Frete Motorista (PF)',
      dataIndex: 'freteMotoristaPf',
      key: 'freteMotoristaPf',
      align: 'center',
      width: 160,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => {
        if (typeof text === 'number') {
          return formatarMoedaIMask(text);
        }
        return text;
      },
    },
    {
      title: 'Frete Total (PJ)',
      dataIndex: 'freteTotalPj',
      key: 'freteTotalPj',
      align: 'center',
      width: 160,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => {
        if (typeof text === 'number') {
          return formatarMoedaIMask(text);
        }
        return text;
      },
    },
    {
      title: 'Frete Total (PF)',
      dataIndex: 'freteTotalPf',
      key: 'freteTotalPf',
      align: 'center',
      width: 160,
      editable: true,
      required: true,
      inputType: 'number',
      render: text => {
        if (typeof text === 'number') {
          return formatarMoedaIMask(text);
        }
        return text;
      },
    },
    {
      title: 'Pedágio Incluso',
      dataIndex: 'pedagioIncluso',
      key: 'pedagioIncluso',
      align: 'center',
      width: 100,
      editable: true,
      required: true,
      inputType: 'select',
    },
    {
      title: 'Data Início',
      dataIndex: 'dataInicio',
      key: 'dataInicio',
      align: 'center',
      width: 135,
      editable: true,
      required: true,
      inputType: 'date',
      render: text => {
        if (moment(text).isValid()) {
          return moment(text).format('DD/MM/YYYY');
        }
        return '';
      },
    },
    {
      title: 'Data Fim',
      dataIndex: 'dataFim',
      key: 'dataFim',
      align: 'center',
      width: 135,
      editable: true,
      required: false,
      inputType: 'date',
      render: text => {
        if (moment(text).isValid()) {
          return moment(text).format('DD/MM/YYYY');
        }
        return '';
      },
    },
    {
      title: 'Observações',
      dataIndex: 'observacoes',
      key: 'observacoes',
      align: 'center',
      width: 300,
      editable: true,
      required: false,
      inputType: 'textArea',
    },
  ];

  return columns.map(col => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: record => ({
        record,
        title: col.title,
        editable: col.editable,
        required: col.required,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        handleSave: handleSaveRow,
        tipoCliente: col.tipoCliente,
        errors: col.dataIndex.includes('frete')
          ? record.errors.frete
          : record.errors[col.key],
      }),
    };
  });
};
